import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; import './Login.css';
import { guessFlag } from '../../utils/flags';
import { applyLoginContext, setAvailableRoles, setRole } from "../../auth/roleService";
import { requestLocationPermission } from '../../utils/location';
import { getFCMToken } from '../../utils/getfcmtoken';

const Login = () => {

  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 1: Mobile, 2: OTP, 3: Registration, 4: GST
  const [countryCodes, setCountryCodes] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [userExists, setUserExists] = useState(false);
  const [password, setPassword] = useState('');
  // const [sellerId, setSellerId] = useState('');

  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [employeeId, setEmployeeId] = useState(null);

  // Registration form fields
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [userTypes, setUserTypes] = useState([]);
  const [selectedUserTypes, setSelectedUserTypes] = useState([]);

  function emojiToISO(emoji) {
    return Array.from(emoji)
      .map(char => char.codePointAt(0) - 0x1F1E6 + 65)
      .map(code => String.fromCharCode(code))
      .join('')
      .toLowerCase();
  }
  const getFlagUrl = iso =>
    `https://flagcdn.com/w20/${iso}.png`; // PNG


  // GST verification
  const [gst, setGst] = useState('');
  const [showGstStep, setShowGstStep] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://192.168.0.11:3000';

  // Available user types
  const availableUserTypes = [
    { id: 1, name: 'Importer', label: 'importer' },
    { id: 2, name: 'Stockist', label: 'stockist' },
    { id: 3, name: 'Export', label: 'export' },
    { id: 4, name: 'DCA', label: 'dca' }
  ];

  const handleAdminLogin = async (e) => {

    e.preventDefault();
    setError("");

    if (!password) {
      setError("Enter password");
      return;
    }

    setLoading(true);

    try {

      const formData = new FormData();

      formData.append("mobile_no", mobile);
      formData.append("password", password);
      formData.append("role", "admin");

      const response = await fetch(
        `${API_BASE_URL}/api/auth/login`,
        {
          method: "POST",
          body: formData
        }
      );

      const data = await response.json();

      if (data.status === 200) {

        localStorage.setItem("authToken", data.data.token);
        localStorage.setItem("role", "admin");
        localStorage.setItem("currentRole", "admin");
        applyLoginContext({
          role: "admin",
          employee_id: data.data.employee_id,
          user_id: data.data.employee_id
        });
        setRole("admin");

        window.location.href = "/dashboard";

      } else {
        setError(data.message);
      }

    } catch (err) {
      setError("Network error");
    }

    setLoading(false);
  };

  // Fetch country codes on component mount
  useEffect(() => {

    const fetchCountryCodes = async () => {
      try {
        const formdata = new FormData();
        formdata.append("search_text", "");

        const response = await fetch(
          `${API_BASE_URL}/api/web/country-list`,
          { method: "POST", body: formdata }
        );

        const result = await response.json();

        if (result.status === 200 && Array.isArray(result.data) && result.data.length) {
          const normalized = result.data.map(c => ({
            id: c.id,
            name: c.name,
            dial_code: c.country_code,
            flagEmoji: c.flag_code,
            iso: emojiToISO(c.flag_code),
            minDigits: Number(c.mobile_no_digit_min),
            maxDigits: Number(c.mobile_no_digit_max),
          }));

          setCountryCodes(normalized);

          const defaultCountry =
            normalized.find(c => c.dial_code === "+91") || normalized[0];

          setSelectedCountry(defaultCountry);
        } else {
          setDefaultCountryCodes();
        }
      } catch (error) {
        console.error("Error fetching country codes:", error);
        setDefaultCountryCodes();
      }
    };

    const setDefaultCountryCodes = () => {
      const defaultCountries = [
        { id: 1, name: "India", dial_code: "+91", minDigits: 10, maxDigits: 10 },
        { id: 2, name: "USA", dial_code: "+1", minDigits: 10, maxDigits: 10 },
        { id: 3, name: "UK", dial_code: "+44", minDigits: 10, maxDigits: 10 },
      ];

      setCountryCodes(defaultCountries);
      setSelectedCountry(defaultCountries[0]);
    };

    fetchCountryCodes();
  }, [API_BASE_URL]);
  ;

  // Step 1: Send OTP
  const handleSendOTP = async (e) => {
    e.preventDefault();
    setError("");

    if (!selectedCountry) {
      setError("Please select country");
      return;
    }

    if (!mobile) {
      setError("Enter mobile number");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("mobile_no", mobile);
      formData.append("country_code_id", selectedCountry.id);


      const response = await fetch(
        `${API_BASE_URL}/api/auth/check-user`,
        {
          method: "POST",
          body: formData
        }
      );

      const data = await response.json();

      if (data.status === 200) {

        const roles = data.data.roles || [];
        setAvailableRoles(roles);
        if (roles.length === 0) {
          setRoles(["seller"]); // default role for new user
          setSelectedRole("seller");
          sendLoginOTP("seller");
        }

        else if (roles.length === 1) {

          if (roles[0] === "admin") {
            setSelectedRole("admin");
            setStep("adminLogin"); // 👈 NEW STEP
          } else {
            setSelectedRole(roles[0]);
            sendLoginOTP(roles[0]);
          }
        }

        else {
          setRoles(roles);
          setStep("selectRole");
        }

      } else {
        setError(data.message);
      }

    } catch (err) {
      setError("Network error");
    }

    setLoading(false);
  };

  const sendLoginOTP = async (role) => {

    setLoading(true);

    try {

      const formData = new FormData();

      formData.append("mobile_no", mobile);
      formData.append("country_code", selectedCountry.dial_code);
      formData.append("country_code_id", selectedCountry.id);
      formData.append("role", role);

      const response = await fetch(
        `${API_BASE_URL}/api/auth/login`,
        {
          method: "POST",
          body: formData
        }
      );

      const data = await response.json();

      if (data.status === 200) {

        setEmployeeId(data.data.employee_id);
        setSelectedRole(role);

        setStep(2);

      } else {
        setError(data.message);
      }

    } catch (err) {
      setError("Network error");
    }

    setLoading(false);
  };

  // Step 2: Verify OTP (check if user exists)
  const handleVerifyOTP = async (e) => {

    e.preventDefault();
    setError("");

    if (!otp) {
      setError("Enter OTP");
      return;
    }

    setLoading(true);

    try {

      const fcmToken = await getFCMToken();
      const formData = new FormData();

      formData.append("employee_id", employeeId);
      formData.append("role", selectedRole);
      formData.append("otp", otp);
      formData.append("device_token", fcmToken || "");
      formData.append("device_type", "android");

      const response = await fetch(
        `${API_BASE_URL}/api/auth/verify-otp`,
        {
          method: "POST",
          body: formData
        }
      );

      const data = await response.json();

      if (data.status === 200) {

        localStorage.setItem("authToken", data.data.token);
        localStorage.setItem("role", data.data.role);
        localStorage.setItem("currentRole", data.data.role);
        applyLoginContext(data.data);
        setRole(data.data.role); // sync legacy `user` after roleEntityIds map is updated

        // ✅ Ask location immediately after login
        try {
          // const location = await requestLocationPermission();
          // const alreadyAsked = localStorage.getItem("locationAsked");
          // let location;
          // if (!alreadyAsked) {
          //   console.log("here");

          //   requestLocationPermission()
          //     .then((location) => {
          //       console.log("📍 Sending location:", location);
          //     })
          //     .catch((err) => {
          //       console.warn("Location not allowed:", err);
          //     });

          //   localStorage.setItem("locationAsked", "true");
          // }


        } catch (err) {
          console.warn("Location not allowed:", err);
        }

        window.location.href = "/dashboard";

      } else {

        setError(data.message);

      }

    } catch (err) {

      setError("Network error");

    }

    setLoading(false);
  };

  // Step 3: Register new user
  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');

    if (!name || name.trim() === '') {
      setError('Please enter your name');
      return;
    }

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    if (selectedUserTypes.length === 0) {
      setError('Please select at least one user type');
      return;
    }

    setLoading(true);

    try {

      const formData = new FormData();

      formData.append('employee_id', employeeId);
      formData.append('role', selectedRole);
      formData.append('otp', otp);

      formData.append('name', name.trim());
      formData.append('email', email.trim());
      formData.append('type_id', selectedUserTypes.join(','));

      const response = await fetch(
        `${API_BASE_URL}/api/auth/verify-otp`,
        {
          method: 'POST',
          body: formData
        }
      );

      const data = await response.json();

      if (data.status === 200) {

        if (data.data?.token) {
          localStorage.setItem('authToken', data.data.token);
        }

        applyLoginContext(data.data);

        if (data.data?.role) {
          localStorage.setItem('role', data.data.role);
          localStorage.setItem("currentRole", data.data.role);
          setRole(data.data.role);
        }

        if (data.data?.entity_id) {
          localStorage.setItem('entityId', data.data.entity_id);
        }

        if (data.data?.require_gst) {
          setStep(4);
        } else {
          // window.location.href = '/dashboard';
          navigate('/dashboard');
        }

        setError('');

      } else {
        setError(data.message || 'Registration failed.');
      }

    } catch (error) {
      console.error('Error registering:', error);
      setError('Network error. Please try again.');
    }

    setLoading(false);
  };

  // Step 4: Verify GST
  const handleVerifyGST = async (e) => {
    e.preventDefault();
    setError('');

    if (!gst || gst.trim() === '') {
      setError('Please enter your GST number');
      return;
    }

    if (gst.length !== 15) {
      setError('GST number must be 15 characters long');
      return;
    }

    setLoading(true);

    try {

      const formData = new FormData();

      formData.append('gst', gst.trim());
      formData.append('role', localStorage.getItem('role'));
      formData.append('entity_id', localStorage.getItem('entityId'));

      const response = await fetch(
        `${API_BASE_URL}/api/auth/verify-gst`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('authToken')}`
          },
          body: formData
        }
      );

      const data = await response.json();

      if (data.status === 200) {
        // window.location.href = '/dashboard';
        navigate('/dashboard');
      } else {
        setError(data.message || 'GST verification failed.');
      }

    } catch (error) {
      console.error('Error verifying GST:', error);
      setError('Network error. Please try again.');
    }

    setLoading(false);
  };

  const handleBack = () => {
    if (step === 2) {
      setStep(1);
      setOtp('');
    } else if (step === 3) {
      setStep(2);
      setName('');
      setEmail('');
      setSelectedUserTypes([1]);
    } else if (step === 4) {
      setStep(3);
      setGst('');
    }
    setError('');
  };

  const handleUserTypeChange = (typeId) => {
    setSelectedUserTypes(prev => {
      if (prev.includes(typeId)) {
        return prev.filter(id => id !== typeId);
      } else {
        return [...prev, typeId];
      }
    });
  };

  const mobileDigits = selectedCountry ? (selectedCountry.mobile_digits || 10) : 10;

  return (
    <div className="login-container">
      <div className="login-left">
        <img
          src="/assets/images/admin_image/login.jpg"
          alt="Industrial warehouse"
          className="login-image"
          onError={(e) => {
            console.error('Image failed to load:', e.target.src);
            e.target.style.display = 'none';
          }}
        />
      </div>
      <div className="login-right">
        <div className="login-form-wrapper">
          <div className="login-logo">
            <img
              src="/assets/images/fortrade_logo.png"
              alt="BSB FORTRADE"
              className="logo-img"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>

          <h2 className="login-title">Welcome to BSB web app!</h2>
          <p className="login-description">
            Login to add materials, track shipments, manage your team & respond to buyer requests.
          </p>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          {step === "selectRole" && (

            <div className="login-form">

              <h3>Select Role</h3>

              {roles.map((role) => (

                <button
                  key={role}
                  className="login-button"
                  onClick={() => {
                    if (role === "admin") {
                      setSelectedRole("admin");
                      setStep("adminLogin");
                    } else {
                      sendLoginOTP(role);
                    }
                  }}
                >
                  Continue as {role}
                </button>

              ))}

              <button
                className="back-button"
                onClick={() => setStep(1)}
              >
                Back
              </button>

            </div>

          )}

          {/* Step 1: Mobile Number with Country Code */}
          {step === 1 && (
            <form className="login-form" onSubmit={handleSendOTP}>
              <div className="form-group">
                <label htmlFor="mobile">Mobile Number</label>
                <div className="mobile-input-wrapper">
                  {/* <select
                    className="country-code-select"
                    value={selectedCountry?.dial_code || ''}
                    onChange={(e) => {
                      const country = countryCodes.find(
                        c => c.dial_code === e.target.value
                      );
                      setSelectedCountry(country);
                      setError("");
                    }}
                  >
                    {countryCodes.map(country => (
                      <option key={country.id} value={country.dial_code}>
                        {country.dial_code}
                      </option>
                    ))}
                  </select> */}

                  <select
                    className="country-code-select"
                    value={selectedCountry?.dial_code || ''}
                    onChange={(e) => {
                      const country = countryCodes.find(cc => cc.dial_code === e.target.value);
                      // If country is not found, create a fallback
                      setSelectedCountry(country || { name: e.target.value, dial_code: e.target.value });
                    }}
                  >
                    {countryCodes.map((c) => (
                      <option key={c.id} value={c.dial_code}>
                        {guessFlag(c)} {c.dial_code} {c.name}
                      </option>
                    ))}
                  </select>



                  <input
                    type="tel"
                    id="mobile"
                    name="mobile"
                    value={mobile}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '').slice(0, mobileDigits);
                      setMobile(value);
                      setError('');
                    }}
                    placeholder={`Enter ${mobileDigits}-digit mobile number`}
                    maxLength={mobileDigits}
                    required
                    autoFocus
                  />
                </div>
              </div>

              <button type="submit" className="login-button" disabled={loading}>
                {loading ? 'Sending OTP...' : 'Get OTP'}
              </button>
            </form>
          )}

          {step === "adminLogin" && (
            <form className="login-form" onSubmit={handleAdminLogin}>

              <div className="form-group">
                <label>Mobile</label>
                <input value={mobile} disabled />
              </div>

              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError('');
                  }}
                  placeholder="Enter password"
                  required
                />
              </div>

              <button type="submit" className="login-button" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>

              <button type="button" className="back-button" onClick={handleBack}>
                Back
              </button>

            </form>
          )}

          {/* Step 2: OTP Verification */}
          {step === 2 && (
            <form className="login-form" onSubmit={handleVerifyOTP}>
              <div className="form-group">
                <label htmlFor="otp">Enter OTP</label>
                <input
                  type="text"
                  id="otp"
                  name="otp"
                  value={otp}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
                    setOtp(value);
                    setError('');
                  }}
                  placeholder="Enter 4-digit OTP"
                  maxLength="4"
                  required
                  autoFocus
                />
                <p className="otp-info">
                  OTP sent to {selectedCountry?.dial_code}{mobile}. <button type="button" className="resend-otp-link" onClick={handleSendOTP}>Resend OTP</button>
                </p>
              </div>

              <button type="submit" className="login-button" disabled={loading}>
                {loading ? 'Verifying...' : 'Verify OTP'}
              </button>

              <button type="button" className="back-button" onClick={handleBack}>
                Back
              </button>
            </form>
          )}

          {/* Step 3: Registration Form (New User) */}
          {step === 3 && (
            <form className="login-form" onSubmit={handleRegister}>
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setError('');
                  }}
                  placeholder="Enter your full name"
                  required
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError('');
                  }}
                  placeholder="Enter your email address"
                  required
                />
              </div>

              <div className="form-group">
                <label>User Type *</label>
                <div className="checkbox-group">
                  {availableUserTypes.map((type) => (
                    <label key={type.id} className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={selectedUserTypes.includes(type.id)}
                        onChange={() => handleUserTypeChange(type.id)}
                      />
                      <span className="checkbox-text">{type.name}</span>
                    </label>
                  ))}
                </div>
              </div>

              <button type="submit" className="login-button" disabled={loading}>
                {loading ? 'Registering...' : 'Continue'}
              </button>

              <button type="button" className="back-button" onClick={handleBack}>
                Back
              </button>
            </form>
          )}

          {/* Step 4: GST Verification */}
          {step === 4 && (
            <form className="login-form" onSubmit={handleVerifyGST}>
              <div className="form-group">
                <label htmlFor="gst">GST Number *</label>
                <input
                  type="text"
                  id="gst"
                  name="gst"
                  value={gst}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase().slice(0, 15);
                    setGst(value);
                    setError('');
                  }}
                  placeholder="Enter your 15-digit GST number"
                  maxLength="15"
                  required
                  autoFocus
                />
                <p className="gst-info">
                  Please enter your valid GST number for verification
                </p>
              </div>

              <button type="submit" className="login-button" disabled={loading}>
                {loading ? 'Verifying GST...' : 'Verify GST'}
              </button>

              <button type="button" className="back-button" onClick={handleBack}>
                Back
              </button>
            </form>
          )}


        </div>
      </div>
    </div>
  );
};

export default Login;
